<template lang="html">
    <d-list-group flush>
      <d-list-group-item class="p-0">
        <d-form @submit.prevent="submit()">
          <d-form-row>

            <!-- Name -->
            <d-col md="6" class="form-group">
              <label for="feName">{{ $t('settings.company.form.name.label') }}</label>
              <d-form-input
                type="text"
                id="feName"
                :placeholder="$t('settings.company.form.name.placeholder')"
                v-model="model.name"
              />
            </d-col>

            <d-col md="3">
              <d-form-row>
                <!-- Color background -->
                <d-col md="6" class="form-group">
                  <label for="feColor">
                    {{ $t('settings.company.form.bgColor.label') }}
                    <small class="text-muted">{{ $t('settings.company.form.bgColor.hint') }}</small>
                  </label>
                  <d-form-input
                    type="color"
                    id="feColor"
                    class="feColor"
                    :placeholder="$t('settings.company.form.bgColor.placeholder')"
                    v-model="model.bgColor"
                  />
                </d-col>

                <!-- Color Font-->
                <d-col md="6" class="form-group">
                  <label for="feFontColor">
                    {{ $t('settings.company.form.fontColor.label') }}
                    <small class="text-muted">{{ $t('settings.company.form.fontColor.hint') }}</small>
                  </label>
                  <d-form-input
                    type="color"
                    id="feFontColor"
                    class="feColor"
                    :placeholder="$t('settings.company.form.fontColor.placeholder')"
                    v-model="model.fontColor"
                  />
                </d-col>

              </d-form-row>
            </d-col>
            <d-col md="3">
              <d-form-row>
                <!-- Color Font-->
                <d-col md="6" class="form-group">
                  <label for="feFontColor">
                    {{ $t('settings.company.form.fontColor2.label') }}
                    <small class="text-muted">{{ $t('settings.company.form.fontColor2.hint') }}</small>
                  </label>
                  <d-form-input
                    type="color"
                    id="feFontColor"
                    class="feColor"
                    :placeholder="$t('settings.company.form.fontColor2.placeholder')"
                    v-model="model.fontColor2"
                  />
                </d-col>
                <!-- Color background -->
                <d-col md="6" class="form-group">
                  <label for="feColor">
                    {{ $t('settings.company.form.titleColor.label') }}
                    <small class="text-muted">{{ $t('settings.company.form.titleColor.hint') }}</small>
                  </label>
                  <d-form-input
                    type="color"
                    id="feColor"
                    class="feColor"
                    :placeholder="$t('settings.company.form.titleColor.placeholder')"
                    v-model="model.titleColor"
                  />
                </d-col>

              </d-form-row>
            </d-col>

          </d-form-row>
          <d-form-row>

            <!-- CNPJ -->
            <d-col md="3" class="form-group">
              <label for="feCNPJ">{{ $t('settings.company.form.cnpj.label') }}</label>
              <masked-input
                type="text"
                class="text-left form-control"
                :class="['is-' + hasErrorFiled('cnpj')]"
                id="feCNPJ"
                v-model="model.cnpj"
                :placeholder="$t('settings.company.form.cnpj.placeholder')"
                :mask="[
                  /[A-Za-z0-9]/, /[A-Za-z0-9]/, '.',
                  /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '.',
                  /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '/',
                  /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '-',
                  /\d/, /\d/
                ]"
                :guide="false"
                @input="uppercaseInput('cnpj')"
              ></masked-input>
            </d-col>

            <!-- Email -->
            <d-col md="3" class="form-group">
              <label for="feEmail">{{ $t('settings.company.form.email.label') }}</label>
              <d-form-input
                :state="hasErrorFiled('email')"
                type="email"
                id="feEmail"
                :placeholder="$t('settings.company.form.email.placeholder')"
                v-model="model.email"
              />
            </d-col>

            <!-- Site -->
            <d-col md="3" class="form-group">
              <label for="feSite">{{ $t('settings.company.form.site.label') }}</label>
              <d-form-input
                type="text"
                id="feSite"
                :placeholder="$t('settings.company.form.site.placeholder')"
                v-model="model.site"
              />
            </d-col>

            <!-- Instagram -->
            <d-col md="3" class="form-group">
              <label for="feInstagram">{{ $t('settings.company.form.instagram.label') }}</label>
              <d-form-input
                type="text"
                id="feInstagram"
                :placeholder="$t('settings.company.form.instagram.placeholder')"
                v-model="model.instagram"
              />
            </d-col>

          </d-form-row>

          <d-form-row>

            <!-- Telefone  Whatsapp-->
            <d-col md="4" class="form-group">
              <label for="feTelefoneWhatsapp1">{{ $t('settings.company.form.whatsapp1.label') }}</label>
              <input-phone
                id="feTelefoneWhatsapp1"
                :placeholder="$t('settings.company.form.phone.placeholder')"
                :model.sync="model.whatsapp1"
              ></input-phone>
            </d-col>

            <!-- Telefone  Whatsapp-->
            <d-col md="4" class="form-group">
              <label for="feTelefoneWhatsapp2">{{ $t('settings.company.form.whatsapp2.label') }}</label>
              <input-phone
                id="feTelefoneWhatsapp2"
                :placeholder="$t('settings.company.form.phone.placeholder')"
                :model.sync="model.whatsapp2"
              ></input-phone>
            </d-col>

            <!-- Telefone  Fixo-->
            <d-col md="4" class="form-group">
              <label for="feTelefone">{{ $t('settings.company.form.phone.label') }}</label>
              <input-phone
                id="feTelefone"
                :placeholder="$t('settings.company.form.phone.placeholder')"
                :model.sync="model.phone"
              ></input-phone>
            </d-col>
          </d-form-row>

          <d-form-row>
            <!-- Endereço -->
            <d-col md="10" class="form-group">
              <label for="feInputEndereco">{{ $t('settings.company.form.address.label') }}</label>
              <d-form-input
                :state="hasErrorFiled('address')"
                type="text"
                id="feInputEndereco"
                :placeholder="$t('settings.company.form.address.placeholder')"
                v-model="model.address"
                @change="capitalizeInput('address')"
              />
            </d-col>

            <!-- Numero -->
            <d-col md="2" class="form-group">
              <label for="feInputNumero">{{ $t('settings.company.form.number.label') }}</label>
              <d-form-input
                :state="hasErrorFiled('number')"
                type="text"
                id="feInputNumero"
                :placeholder="$t('settings.company.form.number.placeholder')"
                v-model="model.number"
              />
            </d-col>
          </d-form-row>

          <d-form-row>
            <!-- Bairro -->
            <d-col md="4" class="form-group">
              <label for="feInputBairro">{{ $t('settings.company.form.district.label') }}</label>
              <d-form-input
                :state="hasErrorFiled('district')"
                type="text"
                id="feInputBairro"
                v-model="model.district"
                @change="capitalizeInput('district')"
              />
            </d-col>

            <!-- Cidade -->
            <d-col md="4" class="form-group">
              <label for="feInputCidade">{{ $t('settings.company.form.city.label') }}</label>
              <d-form-input
                :state="hasErrorFiled('city')"
                type="text"
                id="feInputCidade"
                v-model="model.city"
                @change="capitalizeInput('city')"
              />
            </d-col>

            <!-- Estado -->
            <d-col md="2" class="form-group">
              <label for="feInputEstado">{{ $t('settings.company.form.state.label') }}</label>
              <select-state :validate="hasErrorFiled('state')" :model.sync="model.state"/>
            </d-col>

            <!-- CEP -->
            <d-col md="2"  class="form-group">
              <label for="inputCEP">{{ $t('settings.company.form.zipcode.label') }}</label>
              <masked-input
                type="text"
                class="text-left form-control"
                id="inputCEP"
                v-model="model.zipcode"
                :placeholder="$t('settings.company.form.zipcode.placeholder')"
                :class="['is-' + hasErrorFiled('zipcode')]"
                :mask="[/\d/, /\d/,'.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
                :guide="false"
              ></masked-input>
            </d-col>

          </d-form-row>

          <d-form-row>
            <d-button type="submit" class="btn-primary">{{ $t('shared.actions.save') }}</d-button>
          </d-form-row>
        </d-form>
      </d-list-group-item>
    </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import InputPhone from '_shared/InputPhone.vue';
import MaskedInput from 'vue-text-mask';
import SelectState from '_shared/SelectState.vue';
import SettingsService from '_services/rest/modules/settings';
import MixinValidateForm from '_common/mixins/ValidateForm';
import { capitalize } from '_utils/string';
import { _LOAD_MODEL_COMPANY_, COMPANY } from './SettingsModel';

export default {
  name: 'company-form',
  mixins: [MixinValidateForm],
  components: {
    InputPhone,
    MaskedInput,
    SelectState,
  },
  computed: {},
  data() {
    return {
      model: { ...COMPANY },
      loading: false,
      errors: {
        cnpj: { required: false },
        email: { required: false },
        address: { required: false },
        number: { required: false },
        district: { required: false },
        city: { required: false },
        state: { required: false },
        zipcode: { required: false },
      },
    };
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    capitalizeInput(field) {
      this.model[field] = capitalize(this.model[field]);
    },
    uppercaseInput(field) {
      const value = this.model[field];
      this.model[field] = value ? value.toUpperCase() : value;
    },
    submit() {
      if (this.checkForm()) {
        this.loading = true;
        SettingsService.saveOptions(this.model, 'company')
          .then(() => this.activeAlert({
            message: this.$t('settings.alert.companySaved'),
            theme: 'success',
          }))
          .catch(error => {
            this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
          })
          .finally(this.loading = false);
      }
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_COMPANY_, newValue => {
      this.model = { ...newValue };
    });
  },
};
</script>

<style lang="scss" scoped>
.feColor {
  height: 37px;
}
</style>
